<script setup lang="ts">
import TrackerNodesPage from '../features/tracker-nodes/TrackerNodesPage.vue';
</script>

<template>
  <TrackerNodesPage />
</template>
